import { render, staticRenderFns } from "./leistungen-overview.vue?vue&type=template&id=023699c7&scoped=true"
import script from "./leistungen-overview.vue?vue&type=script&lang=js"
export * from "./leistungen-overview.vue?vue&type=script&lang=js"
import style0 from "./leistungen-overview.vue?vue&type=style&index=0&id=023699c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023699c7",
  null
  
)

export default component.exports